import { config } from '@/config'

function _getCurrentTime() {
	return (new Date()).getTime()
}

function _needToReload(timeStamp, limit) {
	const now = _getCurrentTime()
	if (timeStamp && now - timeStamp <= limit) {
		return false
	}
	else {
		return true
	}
}

export default {
	getFoo: state => state.foo,
	// getConfig: state => config,
	getNetwork: state => state.network,
	getAccount: state => state.account,
	getTokenInfo: state => state.tokenInfo,
	getRelayerInfo: state => state.relayerInfo,
	getUserAccount: state => state.network.userAccount,

	getWeb3Wrapper: state => state.network.web3Wrapper,
	getProviderEngine: state => state.network.providerEngine,
	getContractWrappers: state => state.network.contractWrappers,
	getContractAddresses: state => state.network.contractAddresses,

	getNetworkConfig: state => {
		if (state.network && state.network.id) {
			return config.network[state.network.id]
		}
		else {
			return null
		}
	},

	networkNeedReload: state => _needToReload(state.network.lastLoadTime, config.cacheTime.network),
	tokenInfoNeedReload: state => _needToReload(state.tokenInfo.lastLoadTime, config.cacheTime.tokenInfo),
	relayerInfoNeedReload: state => _needToReload(state.relayerInfo.lastLoadTime, config.cacheTime.relayerInfo),
	accountNeedReload: state => _needToReload(state.account.lastLoadTime, config.cacheTime.account),

	// This is a Hack
	getRelayer: state => {
		const relayerList = config.network[state.network.id].relayers
		if (relayerList.length > 0) {
			for (let relayer of relayerList) {
				if (relayer.name !== 'LedgerDex') {
					return relayer
				}
			}
		}
		return null
	},

	getRelayerList: state => {
		return config.network[state.network.id].relayers
	},

	// getRelayerInfo: state => {
	//   return config.network[state.network.id].relayerInfo
	// },

	// This is a Hack
	getRelayerSupportedERC20AssetPairs: state => {
		const relayerName = 'Mesh'  // hack
		if (state.relayerInfo.ERC20AssetPairs && state.relayerInfo.ERC20AssetPairs[relayerName]) {
			return state.relayerInfo.ERC20AssetPairs[relayerName]
		}
		else {
			return {}
		}
	},

	getSupportedERC20AssetPairsByRelayer: state => relayerName => {
		if (state.relayerInfo.ERC20AssetPairs && state.relayerInfo.ERC20AssetPairs[relayerName]) {
			// console.log(state.relayerInfo.ERC20AssetPairs[relayerName])
			return state.relayerInfo.ERC20AssetPairs[relayerName]
		}
		else {
			return {}
		}
	},


}
